import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { HiStar, HiPlus, HiMinus, HiOutlineShoppingCart, HiOutlineArrowRight } from "react-icons/hi";
import { message } from "antd";
import Footer from "../../Components/Footer/Footer";
import HomeNav from "../../Components/Navbar/NewNavbar";
import Loading1 from "../../Components/Loading/Loading1";
import DetailsModal from '../../Components/DetailsModal/DetailsModal';
import EmptyCartImg from "../../Images/Serviceimg/abandoned-cart.png";
import SofaImg from "../../Images/Redesign/sofa.png";
import SofaCleaningInfo from "./SofaCleaningInfo";

const Sofacleaning = () => {
    const [services, setServices] = useState([]);
    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const servicesCollectionRef = collection(db, "services", "sofa", "0");
                const querySnapshot = await getDocs(servicesCollectionRef);
                let servicesList = [];
                querySnapshot.forEach((doc) => {
                    servicesList.push({ id: doc.id, ...doc.data() });
                });
                setServices(servicesList);
            } catch (error) {
                console.error("Error fetching services:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
        setCart(JSON.parse(localStorage.getItem("cart")) || []);
        
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    const addToCart = (service) => {
        let cartItems = [...cart];
        const existingIndex = cartItems.findIndex((item) => item.id === service.id);

        if (existingIndex > -1) {
            cartItems[existingIndex].qty += 1;
        } else {
            const newItem = { ...service, qty: 1 };
            cartItems.push(newItem);
        }

        localStorage.setItem("cart", JSON.stringify(cartItems));
        message.success({
            content: "Added to cart successfully",
            style: { marginTop: '10vh' }
        });
        setCart(cartItems);
    };

    const updateQty = (index, delta) => {
        const updatedCart = [...cart];
        updatedCart[index].qty += delta;
        if (updatedCart[index].qty <= 0) {
            updatedCart.splice(index, 1);
        }
        setCart(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
    };

    const calculateTotal = () => cart.reduce((acc, item) => acc + (item.discountedPrice * item.qty), 0);

    const openModal = (service) => {
        setSelectedService(service);
        setIsOpen(true);
    };

    if (isLoading) return <Loading1 />;

    return (
        <div className="bg-white min-h-screen">
            <HomeNav />
            
            {/* Service Hero */}
            <section className="relative pt-32 pb-20 bg-secondary overflow-hidden">
                <div className="container-custom relative z-10">
                    <div className="max-w-3xl space-y-6">
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary font-bold text-xs uppercase tracking-widest">
                            <span className="w-2 h-2 bg-primary rounded-full animate-pulse"></span>
                            Premium Upholstery Care
                        </div>
                        <h1 className="text-5xl md:text-7xl font-heading font-black text-foreground">
                            Expert <span className="text-primary italic">Sofa Cleaning</span>
                        </h1>
                        <p className="text-muted-foreground text-lg leading-relaxed max-w-2xl">
                            Restore the luxury of your living space. We combine advanced shampooing techniques with eco-friendly sanitization to breathe new life into your furniture.
                        </p>
                        
                        <div className="flex items-center gap-6 pt-4">
                            <div className="flex items-center gap-2">
                                <span className="text-3xl font-black text-primary">4.6</span>
                                <div className="flex text-accent">
                                    {[1,2,3,4].map(s => <HiStar key={s} size={20} />)}
                                    <HiStar size={20} className="opacity-50" />
                                </div>
                            </div>
                            <div className="w-px h-10 bg-border"></div>
                            <p className="text-sm font-bold text-muted-foreground uppercase tracking-widest">500+ Reviews</p>
                        </div>
                    </div>
                </div>
                <div className="absolute top-0 right-0 w-1/2 h-full opacity-10 md:opacity-100 -z-0 translate-x-1/4">
                    <img src={SofaImg} alt="Luxury Sofa" className="w-full h-full object-cover rounded-l-[100px]" />
                </div>
            </section>

            <section className="py-20">
                <div className="container-custom">
                    <div className="grid lg:grid-cols-12 gap-12">
                        {/* Services List */}
                        <div className="lg:col-span-8 space-y-8">
                            <h2 className="text-3xl font-black text-foreground mb-8">Choose Your Service</h2>
                            
                            <div className="grid sm:grid-cols-2 gap-8">
                                {loading ? (
                                    Array.from({ length: 4 }).map((_, i) => (
                                        <div key={i} className="card-premium h-[450px] animate-pulse">
                                            <div className="h-48 bg-secondary rounded-t-3xl"></div>
                                            <div className="p-8 space-y-4">
                                                <div className="h-6 w-3/4 bg-secondary rounded"></div>
                                                <div className="h-4 w-full bg-secondary rounded"></div>
                                                <div className="h-4 w-2/3 bg-secondary rounded"></div>
                                                <div className="pt-8 flex justify-between">
                                                    <div className="h-8 w-24 bg-secondary rounded"></div>
                                                    <div className="h-10 w-24 bg-secondary rounded-full"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    services.map((service) => (
                                        <div key={service.id} className="card-premium group flex flex-col h-full">
                                            <div className="relative h-56 overflow-hidden">
                                                <img 
                                                    src={service.img} 
                                                    alt={service.name} 
                                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                                                />
                                                <div className="absolute top-4 right-4">
                                                    <div className="bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-full flex items-center gap-1.5 shadow-sm">
                                                        <HiStar className="text-accent" />
                                                        <span className="text-xs font-black">{service.rating}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="p-8 flex-grow space-y-4">
                                                <h3 className="text-xl font-bold group-hover:text-primary transition-colors">{service.name}</h3>
                                                <ul className="space-y-2">
                                                    {(Array.isArray(service.description) ? service.description : [service.description]).slice(0, 3).map((point, idx) => (
                                                        <li key={idx} className="text-sm text-muted-foreground flex gap-2">
                                                            <span className="text-primary mt-1">•</span>
                                                            {point}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>

                                            <div className="p-8 pt-0 border-t border-border/50 mt-auto flex items-center justify-between">
                                                <div className="space-y-1">
                                                    <p className="text-[10px] font-black uppercase tracking-widest text-muted-foreground line-through">₹{service.originalPrice}</p>
                                                    <p className="text-2xl font-black text-primary">₹{service.discountedPrice}</p>
                                                </div>
                                                <div className="flex gap-2">
                                                    <button 
                                                        onClick={() => openModal(service)}
                                                        className="p-3 rounded-xl bg-secondary text-primary hover:bg-primary hover:text-white transition-all shadow-sm"
                                                        title="View Details"
                                                    >
                                                        <HiOutlineArrowRight size={20} />
                                                    </button>
                                                    <button 
                                                        onClick={() => addToCart(service)}
                                                        className="btn-primary !p-3 rounded-xl"
                                                        title="Add to Cart"
                                                    >
                                                        <HiOutlineShoppingCart size={20} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                            <div className="pt-20">
                                <SofaCleaningInfo />
                            </div>
                        </div>

                        {/* Cart Summary (Sticky) */}
                        <div className="lg:col-span-4 lg:sticky lg:top-32 h-fit">
                            <div className="card-premium p-8 space-y-8 bg-secondary/50 border-primary/10">
                                <div className="flex items-center justify-between">
                                    <h3 className="text-xl font-bold">Your Summary</h3>
                                    <span className="px-3 py-1 bg-primary text-white text-[10px] font-black rounded-full uppercase tracking-widest">
                                        {cart.length} Item{cart.length !== 1 ? 's' : ''}
                                    </span>
                                </div>

                                {cart.length > 0 ? (
                                    <>
                                        <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                                            {cart.map((item, index) => (
                                                <div key={index} className="flex items-center justify-between gap-4 p-4 rounded-2xl bg-white shadow-sm">
                                                    <div className="space-y-1 min-w-0">
                                                        <p className="font-bold text-sm truncate">{item.name}</p>
                                                        <p className="text-primary font-black text-sm">₹{item.discountedPrice}</p>
                                                    </div>
                                                    <div className="flex items-center bg-secondary rounded-xl p-1 gap-3">
                                                        <button 
                                                            onClick={() => updateQty(index, -1)}
                                                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-white text-primary hover:bg-primary hover:text-white transition-all"
                                                        >
                                                            <HiMinus size={14} />
                                                        </button>
                                                        <span className="font-black text-sm w-4 text-center">{item.qty}</span>
                                                        <button 
                                                            onClick={() => updateQty(index, 1)}
                                                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-white text-primary hover:bg-primary hover:text-white transition-all"
                                                        >
                                                            <HiPlus size={14} />
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="pt-6 border-t border-border space-y-6">
                                            <div className="flex items-center justify-between text-lg">
                                                <span className="font-bold">Estimated Total</span>
                                                <span className="font-black text-primary text-2xl">₹{calculateTotal()}</span>
                                            </div>
                                            <button 
                                                onClick={() => navigate('/cart')}
                                                className="btn-primary w-full !py-4 shadow-xl hover:shadow-2xl shadow-primary/20"
                                            >
                                                Proceed to Checkout
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="py-12 text-center space-y-6">
                                        <div className="w-24 h-24 bg-primary/5 rounded-full flex items-center justify-center mx-auto opacity-50">
                                            <img src={EmptyCartImg} alt="Empty" className="w-12 h-12 grayscale" />
                                        </div>
                                        <div className="space-y-2">
                                            <p className="font-bold text-foreground/60">Your cart feels lonely</p>
                                            <p className="text-xs text-muted-foreground leading-relaxed">Add some of our premium services to get started.</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            {/* Assured Offer */}
                            <div className="mt-8 p-6 rounded-3xl border-2 border-dashed border-primary/20 bg-primary/5 flex items-start gap-4">
                                <div className="w-12 h-12 shrink-0 rounded-xl bg-primary flex items-center justify-center text-white shadow-lg shadow-primary/20">
                                    <HiPlus className="rotate-45" size={24} />
                                </div>
                                <div className="space-y-1">
                                    <p className="text-sm font-bold">Exclusive Reward</p>
                                    <p className="text-xs text-muted-foreground">Get assured cashbacks via CRED on all premium cleaning bookings.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <DetailsModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                service={selectedService}
            />
        </div>
    );
};

export default Sofacleaning;

